'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

var _propTypes = require('./prop-types');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DrawTab = _react2['default'].createClass({
    displayName: 'DrawTab',


    triesRemaining: _constants2['default'].DRAW_TAB_REDRAW_MAX_RETRIES,
    retryTime: _constants2['default'].DRAW_TAB_REDRAW_INITIAL_INTERVAL,

    propTypes: _extends({}, _propTypes.CommonTabProps, {
        displayOrientation: _propTypes.DeviceOrientation,
        onSignatureData: _propTypes.OnSignatureData
    }),

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'canInsertEverywhere': true
        };
    },
    getInitialState: function getInitialState() {
        return {
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'hasDrawn': false
        };
    },
    componentDidMount: function componentDidMount() {
        this.initCanvas();
    },
    componentWillUnmount: function componentWillUnmount() {
        clearTimeout(this.redrawTimer);
    },
    componentDidUpdate: function componentDidUpdate(prevProps) {
        var orientationHasChanged = prevProps.deviceOrientation != this.props.deviceOrientation || prevProps.displayOrientation != this.props.displayOrientation;
        var screenSizeHasChanged = prevProps.screenSize != this.props.screenSize;
        if (orientationHasChanged || screenSizeHasChanged) {
            // Only reset the canvas if the orientation or size of the screen has changed
            if (this.props.isMobile) {
                this.redrawCanvas();
            } else {
                this.initCanvas();
            }
        }
    },


    //  ----  BEHAVIOR  -----------------------------------

    initCanvas: function initCanvas() {

        var canvasElement = this._getDrawSignatureCanvasElement();
        var canvas = $(canvasElement);

        if (!this.isCanvasNativelySupported() && window.G_vmlCanvasManager) {
            G_vmlCanvasManager.initElement(canvasElement);
        }

        // Preventive reset
        if (canvas.data('canvas')) {
            canvas.canvas('clearCanvas');
            canvas.canvas('destroy');
        }

        // Init
        if (canvas.canvas) {
            // NOTE: Necessary for running unit tests
            canvas.canvas({
                'callback': this.canvasCallback
            });
        }

        canvas.attr('height', parseInt(canvas.height(), 10)).attr('width', parseInt(canvas.width(), 10) + 10); // NOTE: +10 to account for the padding on canvas-holder
    },


    /**
    * redrawCanvas
    *
    * These handle making sure any user entered paths remain during phone rotation
    * We do this by:
    * 1) Saving off the Base64 data from the canvas
    * 2) Reinitializing the canvas to the new, rotated dimensions
    * 3) Set our previous data on the canvas again (with retries to account for animation)
    */

    redrawCanvas: function redrawCanvas() {

        var hasDrawn = !!this.state.hasDrawn;

        // Grab existing signature paths as Base64
        var data = this.getCanvasData();

        // Then reset
        this.initCanvas();

        // Reapply changes
        this._redraw(data);

        // Make sure we show the clear button if we had real data before
        if (hasDrawn) {
            this.setState({
                'hasDrawn': true
            });
        }
    },
    _redraw: function _redraw(imageData) {

        var sourceImage = new Image();
        sourceImage.src = imageData;

        var ctx = this._getDrawSignatureCanvasElement().getContext('2d');
        ctx.drawImage(sourceImage, 0, 0);

        var currentData = this.getCanvasData();

        // Set a timeout to retry if the data doesn't match what we've intended to insert
        // This handles cases where the phone rotation animation hasn't finished
        if (currentData !== imageData && this.triesRemaining > 0) {
            this.retryTime += this.retryTime;
            this.redrawTimer = (0, _setTimeout2['default'])(this._redraw.bind(this, imageData), this.retryTime);
            this.triesRemaining--;
        } else {
            this.retryTime = _constants2['default'].DRAW_TAB_REDRAW_INITIAL_INTERVAL;
            this.triesRemaining = _constants2['default'].DRAW_TAB_REDRAW_MAX_RETRIES;
        }
    },
    _getDrawSignatureCanvasElement: function _getDrawSignatureCanvasElement() {
        var canvas = this.refs.drawSignatureCanvas;

        // this should not happen, but if it does, throw a descriptive error message (CC)
        if (!canvas) {

            if (!this.isMounted()) {
                throw new Error('canvas does not exist since the DrawTab is unmounted.');
            } else {

                // this should definitely not happen (CC)
                throw new Error('canvas does not exist, but the DrawTab is mounted.');
            }
        }

        return canvas;
    },
    canvasCallback: function canvasCallback(eventName) {

        // NOTE: We can't use setState() to keep track of hasDrawn
        // because change a state value triggers render(), which resets the canvas.

        switch (eventName) {

            case 'start':
                this.setState({
                    'hasDrawn': true
                });
                break;

            case 'drag':
                break;

            case 'stop':
                break;

            case 'clear':
                this.setState({
                    'hasDrawn': false
                });
                break;

        }
    },
    clearCanvas: function clearCanvas() {
        var canvas = $(this._getDrawSignatureCanvasElement());
        if (canvas.data('canvas')) {
            canvas.canvas('clearCanvas');
        }
        if (this.redrawTimer) {
            clearTimeout(this.redrawTimer);
        }
        if (this.props.onClear) {
            this.props.onClear();
        }
    },
    insertSignature: function insertSignature(insertEverywhere) {

        var signatureData = {
            'type_code': this.props.type,
            'create_type_code': _constants2['default'].SIGNATURE_TYPE_CANVAS,
            'signature': {
                'image': this.getCanvasData(),
                'is_vml': this.isCanvasNativelySupported() ? 0 : 1
            }

        };

        return this.props.onSignatureData(signatureData, insertEverywhere);
    },


    //  ----  HELPERS  ------------------------------------

    isCanvasNativelySupported: function isCanvasNativelySupported() {
        return !!document.createElement('canvas').getContext;
    },
    getCanvasData: function getCanvasData() {
        var canvasElement = this._getDrawSignatureCanvasElement();
        if (canvasElement) {
            return this.isCanvasNativelySupported() ? canvasElement.toDataURL() : canvasElement.innerHTML;
        }
    },


    //  ----  RENDERING  ----------------------------------

    render: function render() {
        var actionBarProps = this.props.actionBarProps;

        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };

        var clearBtnClasses = {
            'm-sign-modal--tabs--draw--clear-link': true,
            'm-button': true,
            'bg-white': true,
            'border-1-light-grey': true,
            'hbg-white': true,
            'hc-light-grey': true,
            'c-light-grey': true
        };

        var tip = this.props.isMobile ? _react2['default'].createElement(
            'div',
            { className: 'm-sign-modal--tabs--draw--tip' },
            _react2['default'].createElement('span', { className: 'm-sign-modal--tabs--draw--tip--icon' }),
            _react2['default'].createElement(
                'span',
                { className: 'm-sign-modal--tabs--draw--tip--text' },
                this.props.intl.formatMessage({ id: 'signModal.drawn.tip.labelText' })
            )
        ) : null;

        containerClasses[_constants2['default'].TAB_DRAW] = true;

        var clearBtn = this.state.hasDrawn ? _react2['default'].createElement(
            'div',
            {
                'data-test-ref': 'clear-btn',
                ref: 'clearbtn',
                onClick: this.clearCanvas,
                className: (0, _classnames2['default'])(clearBtnClasses) },
            _react2['default'].createElement(
                'a',
                { href: 'javascript:;' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.drawn.clear.linkText' })
            )
        ) : null;

        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(containerClasses) },
            _react2['default'].createElement(
                'span',
                { className: 'm-sign-modal--tabs--tab-title' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.drawn.title', values: { type: this.props.type } })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--tabs--draw' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-sign-modal--tabs--draw--canvas-holder' },
                        this.renderCanvas(),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-sign-modal--tabs--draw--x' },
                            '\xD7'
                        ),
                        clearBtn
                    ),
                    tip
                )
            ),
            _react2['default'].createElement(_actionBar2['default'], _extends({
                'data-test-ref': 'action-bar'
            }, actionBarProps, {
                disableButtons: !this.state.hasDrawn,
                onInsert: this.insertSignature
            }))
        );
    },
    renderCanvas: function renderCanvas() {
        return _react2['default'].createElement('canvas', { ref: 'drawSignatureCanvas',
            id: 'drawSignatureCanvas',
            className: 'm-sign-modal--tabs--draw--canvas' });
    }
});

module.exports = DrawTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/draw-tab.jsx
 ** module id = 792
 ** module chunks = 0 1
 **/